<template>
    <div class="totalizer-overview">
        <div v-if="!isDccAccepted" class="h-text-area">
            <span class="totalizer-overview__subtotal-text" v-text="$ml.get('subtotal')" tabindex="0" />
            <span class="totalizer-overview__subtotal-price" :tabindex="isMobile ? '-1' : '0'">
                R$ {{ formattedSubtotalPrice }}
            </span>
        </div>
        <DiscountOverview />
        <ConvenienceFeeOverview v-if="hasConvenienceFee" />
        <ConversionOverview />
        <ShippingMethodOverview :has-icon="false" />
        <div class="h-text-area">
            <span
                class="totalizer-overview__total-text"
                v-text="$ml.get(isDccAccepted ? 'dccConvertedTotalLabel' : 'total')"
                tabindex="0"
            />
            <span class="totalizer-overview__total-price" :tabindex="isMobile ? '-1' : '0'">
                {{ totalText }}
            </span>
        </div>
    </div>
</template>

<script>
    import moneyHelper from '@/helpers/moneyHelper';
    import { mapGetters } from 'vuex';

    import DiscountOverview from '@/components/OrderOverview/components/DiscountOverview';
    import ConvenienceFeeOverview from '@/components/OrderOverview/components/ConvenienceFeeOverview';
    import ShippingMethodOverview from '@/components/OrderOverview/components/ShippingMethodOverview';
    import ConversionOverview from '@/components/Dcc/ConversionOverview.vue';

    export default {
        components: {
            DiscountOverview,
            ConvenienceFeeOverview,
            ShippingMethodOverview,
            ConversionOverview
        },

        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
            hasConvenienceFee: {
                type: Boolean,
                default: false
            },
            formattedPrice: {
                type: String,
                required: true
            },
            formattedSubtotalPrice: {
                type: String,
                required: true
            }
        },

        computed: {
            // O spread anterior era `...mapGetters`, que espalha o helper e não getters —
            // era inerte. Substituído por uma chamada de verdade.
            ...mapGetters({
                isDccAccepted: 'dcc/getIsAccepted',
                quote: 'dcc/getQuote',
                currency: 'dcc/getCurrencyPresentation'
            }),

            totalText: (self) => self.isDccAccepted
                ? `${self.currency.symbol} ${moneyHelper.formatMinorUnits(self.quote.convertedAmount, self.currency.exponent)}`
                : `R$ ${self.formattedPrice}`,
        },

        methods: {
            formatPrice(unitPrice) {
              let totalPrice = unitPrice / 100; // Transforma centavos em real.

              return `R$ ${moneyHelper.formatToPrice(totalPrice)}`;
          }
        }
    };
</script>

<style lang="scss" scoped>
    .totalizer-overview {
        display: flex;
        flex-direction: column;
        gap: 8px;

        &__subtotal-text {
            color: #5C6A7B;
            font-size: 16px;
            font-weight: 500;
        }

        &__subtotal-price {
            color: #5C6A7B;
            font-size: 16px;
            font-weight: 500;
        }

        &__total-text {
            color: #2F363E;
            font-size: 16px;
            font-weight: 700;

            @media screen and (min-width: 1025px) {
                font-size: 20px;
            }
        }

        &__total-price {
            color: #2F363E;
            font-size: 16px;
            font-weight: 700;

            @media screen and (min-width: 1025px) {
                font-size: 20px;
            }
        }

        .h-text-area {
            display: flex;
            justify-content: space-between;
        }
    }
</style>
